import React, { useState } from 'react';

const OfferPlannerModalContent = (props) => {
  if (!props.items || !props.items.length) {
    return <div>No Items to Display</div>;
  }

  return props.items.map((item, itemIndex) => {
    return (
      <tr>
        {props.renderers.map((renderer, rendererIndex) => {
          return (
            <td
              className={`${
                rendererIndex !== props.renderers.length - 1 ? 'pr-10' : ''
              } text-center whitespace-nowrap`}
            >
              {renderer.render(
                item,
                props.setItems,
                props.offerPlanners,
                props.offerPlannersIndex,
                props.setConfirmationModal,
                props.offerOrAssignProp,
              )}
            </td>
          );
        })}
      </tr>
    );
  });
};

export default OfferPlannerModalContent;
